<template lang="pug">
tr(:class="{ 'destroyed-room': isDestroyed }")
  td {{ room.number }}
  td.floor {{ room.floor }}
  td.layout {{ room.layout }}
  td {{ $n(room.area) }}
  td.rent_fee {{ $n(room.current_rent_fee) }}
  td {{ renovationDateInterior }}
  td {{ renovationDateWet }}
  td.direction {{ direction }}
  td.facility
    a(
      v-b-modal.modal-room-facilities
      @click.prevent='showFacilities'
      href='#'
      v-if="!isDestroyed"
    ) {{ $t('room.show_facilities') }}
  td(:class="{ 'action-text': isDestroyed }")
    .text-right
      a(
        v-b-modal.modal-add-edit-room
        href='#'
        @click.prevent='editRoom'
        :alt="$t('room.edit')"
        v-if="!isDestroyed"
      )
        i.far.fa-edit.icon-action
      button#confirm-delete(v-if="isDestroyed && isExistsRoom" @click="confirmDeleteRoom") 
        span.delete-return-room {{ $t('room.permanently_removed') }}
        b-tooltip(
          target="confirm-delete"
          placement="left"
          :title="$t('room.confirm_delete')"
        )
  td(:class="{ 'action-text': isDestroyed }")
    .text-left
      a.delete-return-room.mr-4(
        href='#'
        @click.prevent='deleteReturnRoom'
        :alt="$t('room.delete')"
      )
        i.far.fa-trash-alt.icon-action(v-if="!isDestroyed")
        span(v-else) {{ $t('room.back') }}
</template>

<script>
  import { api } from '@/api'

  export default {
    props: {
      room: {
        type: Object,
        default() {
          return {}
        }
      },
      isDestroyed: {
        type: Boolean,
        default: false
      }

    },

    computed: {
      renovationDateInterior() {
        if (this.room.renovation_date_interior) {
          return this.$d(new Date(this.room.renovation_date_interior), 'short', 'ja')
        } else {
          return ''
        }
      },

      renovationDateWet() {
        if (this.room.renovation_date_wet) {
          return this.$d(new Date(this.room.renovation_date_wet), 'short', 'ja')
        } else {
          return ''
        }
      },

      direction() {
        if (this.room.direction) {
          return this.$t(`directions.${this.room.direction}`)
        } else {
          return ''
        }
      },

      confirmDeleteRoomUrl() {
        return `properties/${this.$route.params.id}/rooms/${this.room.id}`
      },

      isExistsRoom() {
        return !!this.room.id
      }
    },

    methods: {
      deleteReturnRoom() {
        this.$emit('onRoomDeleteReturn', this.room)
      },

      showFacilities() {
        this.$emit('onShowFacilities')
      },

      editRoom() {
        this.$emit('onRoomEdit')
      },

      confirmDeleteRoom() {
        api.delete(this.confirmDeleteRoomUrl).then(() => {
          this.$emit('confirmDeleteRoom', this.room.id)
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
.icon-action {
  color: #7c91a7;
  font-size: 16px;

  &:hover {
    color: #009cea;
  }
}

td {
  background: #fff;
  border-top: 1px solid #e7ecf4;
  color: #313541;
  font-size: 14px;
}

a {
  color: #008bd0;
}

.facility {
  width: 137px;
}

.direction {
  width: 68px;
}

.floor {
  width: 80px;
}

.layout {
  width: 70px;
}

.rent_fee {
  width: 110px;
}

#confirm-delete {
  background-color: transparent;
  border: 0;
  opacity: 1;
}

.delete-return-room {
  color: #3d4a57;
  text-decoration: none;
}

.destroyed-room {
  td {
    opacity: 0.3;
  }
}

.action-text {
  opacity: 1 !important;
}
</style>
